import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useI18n } from "../i18n";
import { formatPublicationDate } from "../lib/date";

export function PrivacyPage() {
  const { locale, messages } = useI18n();

  return (
    <>
      <Header />
      <main className="legal-page shell">
        <p className="legal-page__date">
          {messages.dates.lastUpdated}{" "}
          <time dateTime="2026-07-26">
            {formatPublicationDate("2026-07-26", "long", locale)}
          </time>
        </p>
        <h1>{messages.privacy.title}</h1>
        <p className="legal-page__lede">{messages.privacy.lede}</p>

        <section>
          <h2>{messages.privacy.collectTitle}</h2>
          <p>{messages.privacy.collectBody}</p>
        </section>

        <section>
          <h2>{messages.privacy.useTitle}</h2>
          <p>{messages.privacy.useBody}</p>
        </section>

        <section>
          <h2>{messages.privacy.storageTitle}</h2>
          <p>{messages.privacy.storageBody}</p>
        </section>

        <section>
          <h2>{messages.privacy.retentionTitle}</h2>
          <p>
            {messages.privacy.retentionBody}{" "}
            <a href="mailto:hello@tunetailor.org">
              <bdi dir="ltr">hello@tunetailor.org</bdi>
            </a>
            .
          </p>
        </section>

        <section>
          <h2>{messages.privacy.statusTitle}</h2>
          <p>{messages.privacy.statusBody}</p>
        </section>
      </main>
      <Footer />
    </>
  );
}
